<template>
    <Modal :is_show="is_show" @click-bg="close()" class="add-creator-modal edit-program-set-pop">
        <header class="edit_program_header">Basic Information <i @click="close()"><svg-icon name="close" /></i>
        </header>
        <Scrollbar class="edit-scroll-list" :show_bar="true">
            <div class="edit_program_body">

                <div class="box" v-if="handle_data[ind.title.i] && handle_data[ind.title.i].can_edit">
                    <div class="edit-item tell-title" v-for="(vv, kk) in handle_data[ind.title.i].question" :key="kk">
                        <div class="line">
                            <div class="name">{{ vv.name }}<div class="red" v-if="vv.client_view.setting_number===1">*</div></div>
                            <input type="text" v-model="vv.client_view.val" />
                        </div>
                    </div>
                </div>

                <div class="box head-basic">
                    <div class="desc">Select application template:</div>
                    <Dropdown :items="sort_select" :direction_type="'right'"
                        :icon_direction_type="'right'" :default_id="porgram_for_who" @update-dropdown="updateSort" :disabled="type !=='create' || is_copy"/>
                    <div class="desc"><div class="red">*</div>Indicates required field</div>
                </div>

                <div class="box question-templeat">
                    <div class="desc">Questions</div>
                    
                    <!-- question top-->
                    <!-- title,summary 在另一個區域編輯//last name會跟著first name同進退，永遠必填，所以在這邊都不會顯示 -->
                    <div class="edit-item" v-for="(v, k) in handle_data.filter(e=>{return e.group_name!=='title' && e.group_name !== 'summary' && e.group_name !== 'tell_us_about_yourself_title' && e.group_name !== 'last_name' && !e.more_qu && e.can_edit })" :key="k">
                        <div class="line">
                            <div class="name">{{ v.name }}<div class="red" v-if="v.setting_number===1">*</div></div>
                            <div class="desc" v-if="v.setting_number===1">Default</div>
                            <div class="handle_req" v-else>
                                <div class="req-box" v-if="v.setting_number===3 && v.is_switch" @click=" v.is_required = (country_is_req && v.group_name==='country_location') || findRe(v) ? true :  !v.is_required" >
                                    <Checkbox :checked="v.is_required" />
                                    Required
                                </div>
                                
                                <Switch :checked="v.is_switch" @click.native="hanleAllQus(v)" />
                            </div>
                        </div>

                        <!-- **question group-birthday** -->
                        <div class="group" v-if="v.group_name==='date_of_birth'" v-show="v.is_switch">
                            <div class="edit-item" v-for="(vv, kk) in v.question.filter((gqe, gqk) => { return gqk !== 0 })" :key="kk">
                                <div class="line">
                                    <div class="name">{{ vv.name }}</div>
                                    <Dropdown :items="vv.input_option" :direction_type="'right'"
                                    :icon_direction_type="'right'" :default_text="vv.val" :default_value="vv.val? -100 : 0" @update-dropdown="updateSort" />
                                </div>
                            </div>
                        </div>
                        <!-- **question address** -->
                        <div class="group-address" v-if="v.group_name==='address'" v-show="v.is_switch ||v.required">
                            <div class="edit-item" v-for="(vv, kk) in v.question.filter((gqe, gqk) => { return gqk == 1 })" :key="kk">
                                <div class="line">
                                    <div class="desc" v-if="!vv.is_editing">{{temp_data.address_description}}</div>
                                    <input type="text" v-model="temp_data.address_description" @keyup.enter="vv.is_editing=false" v-else />
                                    <svg-icon class="svg-icon-edit" name="pen" @click="vv.is_editing =vv.is_editing ?false:true"/>
                                </div>
                            </div>
                        </div>

                        <!-- **question group** -->
                        <!-- 只有country_location要必填才讓子曾全SHOW，其他只要開啟就顯示 -->
                        <div class="group" v-if="v.question.length > 1 && v.group_name!=='date_of_birth' && v.group_name!=='address'" v-show="  v.is_switch || ( !v.require_configurable && v.required )">
                            <div class="edit-item" v-for="(vv, kk) in v.question.filter((gqe, gqk) => { return gqk !== 0 })" :key="kk">
                                <div class="line">
                                    <div class="name">{{ vv.name }}</div>

                                    <div class="desc" v-if="vv.client_view.setting_number===1">Default</div>
                                    <!-- 如果子曾被選為必填，父層也要一起連動 -->
                                    <div class="handle_req" v-else>
                                        <div class="req-box" v-if=" vv.client_view.setting_number=== 3 && vv.client_view.show" @click="vv.client_view.is_required = !vv.client_view.is_required; v.is_required= findRe(v) ? findRe(v): v.is_required" >
                                            <Checkbox :checked="vv.client_view.is_required" />
                                            Required
                                        </div>
                                        <Switch :checked="vv.client_view.show" @click.native="vv.client_view.show = !vv.client_view.show; vv.client_view.is_required=!vv.client_view.show? false:vv.client_view.is_required" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- more question -->
                    <div class="desc-box" @click="handleMorQues">
                        <div class="desc">More</div>
                        <div class="hr"></div>
                        <svg-icon name="arrow" class="svg-icon-edit" :class="{'less': !show_question_template}" />
                    </div>
                    <div class="show-qu" v-if="show_question_template">
                        <div class="edit-item" v-for="(v, k) in handle_data.filter(e=>{return e.more_qu && e.can_edit })" :key="k">
                            <div class="line">
                                <div class="name">{{ v.name }}<div class="red" v-if="v.required && !v.require_configurable">*</div></div>
                                <div class="desc" v-if="v.required && !v.require_configurable">Default</div>
                                <div class="handle_req" v-else>
                                    <div class="req-box" v-if="v.required && v.is_switch" @click="v.is_required = v.is_required ? false : true">
                                        <Checkbox :checked="v.is_required" />
                                        Required
                                    </div>
                                    <Switch :checked="v.is_switch" @click.native="v.is_switch = v.is_switch? false: true" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Scrollbar>
        <!-- save -->
        <div class="save-btn-box">
            <Button class="save-btn" size="40" color="dark-blue" :border_r="6" @click="save">
                Save
            </Button>
        </div>
    </Modal>

</template>

<script>
import Button from '@/components/ui/Button.vue';
import Modal from '@/components/ui/Modal.vue';
import Loading from '@/components/ui/Loading.vue';
import NoData from '@/components/creator/NoData.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import Switch from '@/components/ui/Switch.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import * as yup from 'yup';
import moment from 'moment';
import { getIndex } from '@/utils/ProgramsData.js';

export default {
    name: 'ProgramForm',
    emits: ['close','save'],

    data() {
        return {
            sort_select:this.$store.state.program_data.form_ForCreatorList,
            sort_index:0,
            show_question_template:false,
            handle_data:[],
            temp_data:{
                address_description:'',
            },
            //data_index
            ind:{
                address:{ii:0,i:0},
                address_des:{ii:0,i:0},
                title:{ii:0,i:0}
            }
        }
    },

    props: {
        is_show: {
            type: Boolean,
            default: true,
        },
        data: {
            type: Array,
            default: []
        },
        other_data:{
            type: Object,
            default: {}
        },
        is_edit: {
            type: Boolean,
            default: false,
        },
        porgram_for_who:{
            type:[ String , Number ],
            default:1,
        },
        type:{
            type: String ,
            default:'creater',
        },
        is_copy:{
            type: Boolean,
            default: false,
        },
    },

    computed: {
        //如果打開且country打開，只能必填
        country_is_req(){
            //目前只讓country影響lacation,當他非必填的狀態就關閉lacation
            // let arr= this.other_data.settings[3].section_groups.filter(e=>{return e.group_name ==='auto_rejection_location'});
            // let is_auto_rej=arr[0].is_switch;
            // return is_auto_rej;
            return false;
        }
    },

    components: {
        Scrollbar,
        Button,
        Modal,
        NoData,
        Loading,
        Dropdown,
        Switch,
        Checkbox,
    },

    watch: {
        country_is_req(val){
            if(val){
                let index = getIndex(this.handle_data ,'country_location', 'country_location');
                this.handle_data[index.i].is_required=true;
                this.handle_data[index.i].is_switch=true;
            }
        }
    },

    methods: {
        findRe(v){
            return v.question.some(item => item.client_view && item.client_view.is_required && item.index!==0 );
        },

        hanleAllQus(v){
            v.is_switch = this.country_is_req && v.group_name==='country_location' ? true :!v.is_switch;  
            v.is_required = this.country_is_req && v.group_name==='country_location'? true:!v.is_switch? false: v.is_required;
            if(!v.is_switch){
                v.question.forEach(e => {
                    if(e.client_view){
                        e.client_view.show=false;
                        e.client_view.is_required=false;
                    }
                });
            }
        },

        updateSort(val){
            const index = this.handle_data.findIndex(item => item.group_name === "date_of_birth");
            if(val.type==='format'){
                let ii = this.handle_data[index].question.findIndex(item => item.label === 'format');
                this.handle_data[index].question[ii].val=val.text;
            }else if(val.type==='minimal_age_requirement'){
                let ii = this.handle_data[index].question.findIndex(item => item.label === 'minimal_age_requirement');
                this.handle_data[index].question[ii].val=val.text;
            }else if(val.type==='application_template'){
                this.sort_index=val.id;
                this.$emit('save',{data:this.handle_data,type:'creator', ambassador_application_template_id:this.sort_index});
            }
        },

        handleMorQues(){
            this.show_question_template=this.show_question_template? false:true;
        },

        save(){
            this.setDate();
            this.$emit('save',{data:this.handle_data,type:'creator'});
        },

        close(){
            this.$emit('close');
        },
        
        setDate() { 
            this.handle_data[this.ind.address_des.i].question[this.ind.address_des.ii].is_editing=false;
            this.handle_data[this.ind.address_des.i].question[this.ind.address_des.ii].val=this.temp_data.address_description;
            this.handle_data[this.ind.address.i].question[this.ind.address.ii].client_view.spec_val=this.temp_data.address_description;
           
        }
    },


    mounted() {
        const clone_data = JSON.parse(JSON.stringify(this.data));//make sure the data will change

        if (this.$ProjectName === 'sephora') {
            // remove year from date_of_birth P42-10308
            clone_data.forEach(e => {
                if (e.group_name === 'date_of_birth') {
                    e.question.forEach(item => {
                        if (item.input_type === 'toggle') item.client_view.plac = item.client_view.plac.replace(/\/YYYY|YYYY\//g, '');

                        if (item.input_type === 'single_select') {
                            item.input_value = item.val.replace(/\/YYYY|YYYY\//g, '');
                            item.val = item.val.replace(/\/YYYY|YYYY\//g, '');
                            item.input_option.forEach(e => {
                                // Remove /YYYY or YYYY/ from date formats
                                e.text = e.text.replace(/\/YYYY|YYYY\//g, '');
                            });
                        }
                    });
                }
            });
        }

        this.handle_data = clone_data;
        this.ind.address=getIndex( this.handle_data,'address','address');
        this.ind.address_des=getIndex( this.handle_data,'address','address_description');
        this.ind.title=getIndex( this.handle_data,'tell_us_about_yourself_title','tell_us_about_yourself_title');
        this.temp_data.address_description= this.handle_data[this.ind.address_des.i].question[this.ind.address_des.ii].val;


        
        this.show_question_template = this.handle_data.filter(e=>{return e.more_qu && e.can_edit }).some(e => e.is_switch);
    },

}
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.edit_program_body {
    .head-basic{
        .ui-dropdown{
            margin: 12px 0;
        }
    }

    .question-templeat{
        .des{
            margin-top: 12px;
        }
    }

    .group-address{
        .line{
            @include flexCenter();

            .desc{
                flex:1;
            }

            .svg-icon{
                margin-left: 16px;
            }


        }
    }
    
}
</style>